import PermissionTables from "./PermissionTable";
import "./Permission.css";

function Permissions() {

  return (
    <div className="permissions-container">
      <div className={`permissions-slider `}>
        {/* Welcome page */}
          <div className="w-full h-full flex items-center justify-center flex-col">
            <PermissionTables />
          </div>

        {/* Login page */}
      </div>
    </div>
  );
}

export default Permissions;
